var map = {
	"./bg00.jpg": "0f18",
	"./bg01.jpg": "695e",
	"./bg02.jpg": "8539",
	"./bg03.jpg": "0a36",
	"./bg04.jpg": "1cda",
	"./bg05.jpg": "8bb6",
	"./bg06.jpg": "1064"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "40ec";